<template>
  <div class="main-menu">
    <sPopover
      v-if="breakpoint.smAndDown"
      v-model="showMenuMobile"
      class="my-auto"
      data-qa="mobile-menu"
      placement="bottom-start"
      popper-class="main-menu__mobile-menu"
      trigger="click">
      <div
        slot="reference"
        class="main-menu__mobile-btn"
        :class="{'active' : showMenuMobile}"/>
      <div>
        <template
          v-for="link in main_links">
          <MenuItem
            v-if="!link.meta.casl || $can( ...link.meta.casl )"
            :key="link.name"
            icon="table"
            :label="$t(link.meta.caption)"
            :to="{name: link.name, params: {org: $route.params.org} }"
            @beforeEnter="closeAllMenu"/>
          <template v-if="links_in_menu.length && link.name == 'tenders'">
            <sDivider
              :key="`divider-${link.name}`"/>
            <TenderMenu
              :key="`items-${link.name}`"
              :value="links_in_menu"
              @closeMenu="closeAllMenu"/>
          </template>
        </template>
      </div>
    </sPopover>
    <a
      class="main-menu__logo"
      :href="$router.resolve({ name: 'homePage' }).href">
      <img
        v-if="ny"
        class="ny-cap"
        :src="`${siteHref}/img/cap-ny.svg`"
        style="position: absolute;left: -13px;top: -8px;width: 20px;transform: rotateZ(316deg) scaleX(-1);/* transform: revert; */">
    </a>
    <div
      v-if="!breakpoint.smAndDown"
      class="main-menu__menu"
      data-qa="mail-menu">
      <template
        v-for="link in main_links">
        <div
          v-if="!link.meta.casl || $can( ...link.meta.casl )"
          :key="link.name"
          class="main-menu__menu-item">
          <router-link
            class="pa-3"
            :class="{'pr-2': links_in_menu.length && link.name == 'tenders'}"
            exact-active-class="opacity-7"
            :to="{name: link.name, params: {org: storedCurrentOrganization.organizationItId} }">
            {{ $t(link.meta.caption) }}
          </router-link>
          <sPopover
            v-if="links_in_menu.length && link.name == 'tenders'"
            v-model="showTenderMenu"
            placement="bottom-end"
            popper-class="main-menu__sub-menu"
            trigger="click"
            width="400">
            <div
              slot="reference"
              class="pointer"
              data-qa="open-menu">
              <sIcon
                color="var(--text-color)"
                :rotate="showTenderMenu ? '-180' : '0'"
                size="10"
                type="arrow"/>
            </div>
            <TenderMenu
              :value="links_in_menu"
              @closeMenu="closeAllMenu"/>
          </sPopover>
          <sDivider/>
        </div>
      </template>
    </div>
    <div class="main-menu__user">
      <UserPanel
        :visible.sync="showUserMenu"/>
    </div>
  </div>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import UserPanel from 'components/header/UserPanel.vue'
import TenderMenu from 'components/header/TenderMenu.vue'

import { mapGetters } from 'vuex'
import displaySize from 'mixins/display-size'
import godModeMixin from 'mixins/godModeMixin'


const menus = ['showTenderMenu', 'showMenuMobile', 'showUserMenu']

export default {
  name: 'layoutMenu',
  mixins: [displaySize, godModeMixin],
  data() {
    return {
      siteHref: window.config?.BaseUrl,
      showTenderMenu: false,
      showMenuMobile: false,
      showUserMenu: false,
      ny: false,
    }
  },
  methods: {
    closeAllMenu(without) {
      menus.forEach((menuItem) => {
        if (!without || without !== menuItem) {
          this[menuItem] = false
        }
      })
    },
  },
  computed: {
    ...mapGetters({
      links: 'getRouterLinks',
      storedCurrentOrganization: 'getCurrentOrganization',
    }),
    availableLinks() {
      const isAccessAutomationsPage = (this.$acl.check('tenderAdmin') && this.$can('use', 'automationAvaliable')) || this.mixin_isGodMode
      const isAccessGroupOfAccreditations = this.$can('show', 'useGroupAccreditations') || this.mixin_isGodMode
      return this.links.filter(el => {
        if (el.name === 'automationsPage' && !isAccessAutomationsPage) {
          return false
        }
        if (el.name === 'groupOfAccreditationsList' && !isAccessGroupOfAccreditations) {
          return false
        }
        return true
      })
    },
    main_links() {
      return this.availableLinks.filter(elem => !elem.meta.link) || []
    },
    links_in_menu() {
      let result = this.availableLinks.filter(elem => elem.meta.link) || []

      const useHrefProp = ['analytic', 'myaccreditedsuppliers']
      result.forEach(element => {
        if (element.meta.externalLink) {
          let userManagerAfterHref = element.meta.link
          if (this.mixin_isGodMode && useHrefProp.includes(element.name)) {
            userManagerAfterHref += 'GodMode'
          }
          element.href = this.$t(userManagerAfterHref, { ...this.link_prepend })
        }
      })

      result.push({
        name: 'signy',
        href: window.config.MySignyUrl,
        meta: {
          caption: 'Menu.Signy',
          icon: 'signy',
          externalLink: true,
        },
      })
      return result
    },
    link_prepend() {
      const result = this.$_.cloneDeep(window.config ?? {})
      result.org = this.storedCurrentOrganization.organizationId
      return result
    }
  },
  components: {
    MenuItem,
    UserPanel,
    TenderMenu,
  },
  created() {
    const date = new Date()
    this.ny = (date.getMonth() === 11 && date.getDate() >= 15 || date.getMonth() === 0 && date.getDate() <= 15)
  },
  watch: {
    '$route'() {
      this.closeAllMenu()
    }
  }
}
</script>
<style scoped lang="scss">
.dark-theme .ny-cap {
  filter: invert(1);
}
.main-menu {
  width: 100vw;
  max-width: 100vw;
  overflow: hidden;
  height: 64px;
  tab-size: 4;
  font-size: 16px;
  text-align: center;
  border-bottom: 2px solid var(--black-color);
  z-index: 100;
  color: var(--black-color);
  padding: 0 16px 0 10px;
  display: grid;
  align-content: center;
  grid-template-columns: 175px 1fr 370px;
  @media (max-width: 1175px) {
    grid-template-columns: 175px 1fr 195px;
  }
  @media (max-width: 1010px) {
    grid-template-columns: 72px 1fr 195px;
  }
  @media (max-width: 935px) {
    grid-template-columns: 22px 1fr 280px;
  }
  @media (max-width: 475px) {
    grid-template-columns: 22px 1fr 70px;
  }
  /*@media (max-width: 1095px) {
    grid-template-columns: 35px 1fr 295px;
  }
  @media (max-width: 745px) {
    grid-template-columns: 24px 1fr;
  }*/
  &__logo {
    width: 145px;
    height: 17px;
    margin: auto 0;
    margin-left: 0;
    position: relative;
    background-size: contain;
    background-position: center;
    background-image: url("data:image/svg+xml,%3Csvg fill='none' height='17px' viewBox='0 0 145 17' width='145px' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.7872 0.624839C3.21995 0.624839 0 1.89062 0 5.57494C0 8.71679 2.06686 9.64352 6.1353 10.5477C8.13689 10.9997 8.89837 11.2257 8.89837 12.1525C8.89837 13.1696 8.11514 13.9833 6.26584 13.9833C4.39479 13.9833 3.63332 13.1922 3.30697 12.0847H0.152291C0.500394 14.7066 2.1974 16.9896 6.2876 16.9896C9.1812 16.9896 12.0313 15.3395 12.0313 12.0169C12.0313 8.89762 9.59457 7.97089 6.87502 7.3832C4.19898 6.77292 3.13292 6.61469 3.13292 5.43933C3.13292 4.30916 4.04669 3.63107 5.80896 3.63107C7.96284 3.63107 8.87661 4.42218 9.28998 5.9818H12.4229C12.0748 3.24681 10.2473 0.624839 5.7872 0.624839ZM17.035 16.7289L17.0133 10.4501C17.0133 8.55996 17.8835 7.47367 19.5152 7.47367C21.0164 7.47367 21.5821 8.32098 21.5821 9.84178V16.7289H24.6933V10.4501C24.6933 8.55996 25.5418 7.47367 27.1735 7.47367C28.6747 7.47367 29.2403 8.32098 29.2403 9.84178V16.7289H32.3515V9.16829C32.3515 6.27876 30.7633 4.51897 28.2178 4.51897C26.4555 4.51897 25.0849 5.36627 24.2146 6.77845C23.5619 5.32282 22.3001 4.51897 20.5813 4.51897C19.0148 4.51897 17.8835 5.17074 17.035 6.36566V4.77967H13.9021V16.7289H17.035ZM33.5775 10.7543C33.5775 14.4238 35.9711 16.9993 39.0823 17C40.7823 16.9996 42.0608 16.2216 42.8562 15.0605V16.7289H45.9708V4.77967H42.8562V6.50166C42.0664 5.32719 40.8024 4.53153 39.1345 4.50923L39.0638 4.5088L38.9727 4.50953C35.9662 4.56038 33.5775 7.09997 33.5775 10.7543ZM39.7927 14.0383C38.0654 14.0386 36.7241 12.7226 36.7248 10.7549C36.7241 8.7959 38.0556 7.4702 39.792 7.47345C41.531 7.4702 42.8586 8.79981 42.859 10.7558C42.8586 12.7265 41.5349 14.0386 39.7927 14.0383ZM57.0979 16.7289V14.1878H53.3613V11.406C53.3613 8.58169 55.0583 7.71266 57.0382 7.71266C57.3863 7.71266 57.5603 7.73438 57.7997 7.75611V4.56242C57.6038 4.54069 57.3863 4.51897 57.1034 4.51897C55.4064 4.51897 54.1011 5.30109 53.3613 6.86535L53.3446 4.78603H47.8736V7.61047L50.2442 7.57974L50.2274 14.1878H47.8736V16.7289H57.0979ZM63.968 16.9896C65.404 16.9896 66.8834 16.4682 67.5361 16.0336L67.0139 13.5134C66.0349 13.8611 65.2081 14.1 64.5119 14.1C63.2718 14.1 62.5974 13.3614 62.5974 11.9492V7.71266H67.0357V4.77967H62.5974V1.52081L59.4862 2.19431V12.123C59.4862 15.5557 61.5748 16.9896 63.968 16.9896ZM80.0768 16.7289V3.84764H84.4007V0.885549H72.6509V3.84764H76.9622V16.7289H80.0768ZM89.5821 16.9993C92.4933 16.9993 95.0917 15.2648 95.5801 12.327L92.3782 12.3266C92.091 13.6264 90.9397 14.3577 89.5958 14.3577C87.8673 14.3536 86.5989 13.1784 86.4907 11.3335H95.6045C95.6517 10.9531 95.6926 10.4827 95.6173 9.85526C95.2392 6.58813 92.5771 4.50897 89.4892 4.50897V4.50919C85.9727 4.51136 83.3265 7.20645 83.3265 10.7604C83.3265 14.3036 85.9573 16.9993 89.5821 16.9993ZM92.3441 9.25628H86.712C87.0744 7.92101 88.1473 7.06588 89.5423 7.06219V7.06197C90.797 7.06197 92.0549 7.78761 92.3441 9.25628ZM100.25 16.7289V10.4501C100.25 8.49479 101.185 7.47367 102.947 7.47367C104.601 7.47367 105.188 8.34271 105.188 9.90696V16.7289H108.299V9.23346C108.299 6.30048 106.668 4.51897 103.97 4.51897C102.316 4.51897 101.12 5.19247 100.25 6.40911V4.77967H97.1384V16.7289H100.25ZM115.146 17C116.846 16.9996 118.124 16.2216 118.92 15.0605V16.7289L122.035 16.7289V0H118.92V6.50166C118.119 5.31065 116.83 4.50919 115.128 4.50875C112.078 4.50919 109.641 7.06306 109.641 10.7543C109.641 14.4238 112.035 16.9993 115.146 17ZM115.856 14.0386C114.129 14.0386 112.788 12.7226 112.788 10.7549C112.788 8.79612 114.119 7.47041 115.856 7.47367V7.47345C117.595 7.4702 118.922 8.80003 118.923 10.7558C118.922 12.7265 117.598 14.0386 115.856 14.0386ZM129.799 16.9993C132.71 16.9993 135.309 15.2648 135.797 12.327L132.595 12.3266C132.308 13.6264 131.157 14.3577 129.813 14.3577C128.084 14.3536 126.816 13.1784 126.708 11.3335H135.821C135.869 10.9531 135.91 10.4827 135.834 9.85526C135.456 6.58813 132.794 4.50897 129.706 4.50897V4.50919C126.19 4.51136 123.543 7.20645 123.543 10.7604C123.543 14.3036 126.174 16.9993 129.799 16.9993ZM132.584 9.25628H126.952C127.315 7.92101 128.387 7.06588 129.782 7.06219V7.06197C131.037 7.06197 132.295 7.78761 132.584 9.25628ZM140.466 16.7289V11.406C140.466 8.58169 142.163 7.71266 144.143 7.71266C144.491 7.71266 144.665 7.73438 144.905 7.75611V4.56242C144.709 4.54069 144.491 4.51897 144.209 4.51897C142.512 4.51897 141.206 5.30109 140.466 6.86535V4.77967H137.355V16.7289H140.466Z' fill='black'/%3E%3C/svg%3E");
    @media (max-width: 934px) {
      height: 100%;
      width: 205px;
      margin-left: 15px;
    }
    @media (max-width: 934px) {
      width: 30px;
      height: 30px;
      background-size: contain;
      background-image: url("data:image/svg+xml,%3Csvg fill='none' height='24px' viewBox='0 0 24 24' width='24px' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18.0466 0H5.95336C2.66541 0 0 2.66541 0 5.95336V18.0466C0 21.3346 2.66541 24 5.95336 24H18.0466C21.3346 24 24 21.3346 24 18.0466V5.95336C24 2.66541 21.3346 0 18.0466 0Z' fill='black'/%3E%3Cpath clip-rule='evenodd' d='M11.6648 5.3003C9.57297 5.3003 6.94936 6.33166 6.94936 9.33365C6.94936 11.8936 8.63343 12.6487 11.9484 13.3854C13.5793 13.7537 14.1997 13.9379 14.1997 14.693C14.1997 15.5218 13.5616 16.1848 12.0548 16.1848C10.5302 16.1848 9.90978 15.5402 9.64388 14.6378L7.07345 14.6378C7.35708 16.7742 8.7398 18.6343 12.0725 18.6343C14.4302 18.6343 16.7524 17.2898 16.7524 14.5825C16.7524 12.041 14.767 11.2859 12.5511 10.807C10.3707 10.3098 9.50206 10.1808 9.50206 9.22314C9.50206 8.30229 10.2466 7.74978 11.6825 7.74978C13.4375 7.74978 14.182 8.39437 14.5188 9.66515H17.0715C16.7879 7.43668 15.2988 5.3003 11.6648 5.3003Z' fill='white' fill-rule='evenodd'/%3E%3C/svg%3E");
    }
  }
  &__menu {
    display: grid;
    grid-template-columns: max-content max-content max-content 1fr;
    grid-gap: 10px;
    margin-left: 70px;
    @media (max-width: 934px) {
      display: none;
    }
    /*@media (max-width: 745px) {
      display: none;
    }*/
    &-item {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 500;
      transition: all 0.25s;
      a:not(.router-link-exact-active):hover,
      a:not(.router-link-exact-active):focus {
        opacity: 0.5;
      }
    }
  }
  &__user {
    display: flex;
    justify-content: flex-end;
  }
  &__mobile-btn {
    --mobile-btn-size: 22px;
    position: relative;
    cursor: pointer;
    height: var(--mobile-btn-size);
    width: var(--mobile-btn-size);
    border: 2px solid var(--black-color);
    border-right-width: 0;
    border-left-width: 0;
    transition: all 0.15s;
    &:after,
    &:before {
      position: absolute;
      content: "";
      left: 0;
      bottom: 8px;
      width: var(--mobile-btn-size);
      height: 2px;
      transition: all 0.25s;
      background: var(--black-color);
    }
    &.active {
      border-top-color: transparent;
      border-bottom-color: transparent;
      &:after {
        transform: rotate(45deg);
        left: -4px;
        top: 8px;
        width: calc(var(--mobile-btn-size) + 4px);
      }
      &:before {
        transform: rotate(-45deg);
        left: -4px;
        bottom: 8px;
        width: calc(var(--mobile-btn-size) + 4px);
      }
    }
  }
}
</style>

<style lang="scss">
.main-menu {
  &__sub-menu {
    box-shadow: 1px 1px 4px -2px transparent !important;
    border-radius: 0 0 4px 4px;
    border: 2px solid var(--v-main__green-base) !important;
    background-color: var(--v-secondary__green_chosen-base) !important;
  }
  &__mobile-menu {
    margin-top: 9px !important;
    border: 2px solid var(--v-main__green-base)!important;
    background-color: var(--v-secondary__green_chosen-base)!important;
    border-radius: 0 0 4px 4px;
    &-item {
      padding: 5px 10px;
      font-weight: 500;
      text-align: left;
    }
    @media (max-width: 410px) {
      width: 100% !important;
      left: 0 !important;
      right: 0 !important;
    }
  }
}
.dark-theme .main-menu__logo {
  filter: invert(1);
}
</style>
